import { useStablesMarketQuotes } from "../../../Hooks/useStablesMarketQuotes";
import { StablesQuotesCarousel } from "../StablesQuotesCarousel";

export const StablesQuotesSection = ({
  showViewAll = true,
  viewAllLink = "/stables",
  quoteState: quoteStateProp = null,
}) => {
  const internalQuoteState = useStablesMarketQuotes({
    carouselOnly: true,
    autoRefreshMs: 8000,
    enabled: !quoteStateProp,
  });
  const quoteState = quoteStateProp ?? internalQuoteState;

  const isSilentRefresh =
    quoteState.refreshing || (quoteState.loading && quoteState.quotes.length > 0);

  return (
    <div className="stables-quotes-card mb-5">
      <StablesQuotesCarousel
        showViewAll={showViewAll}
        viewAllLink={viewAllLink}
        quotes={quoteState.quotes}
        loading={quoteState.loading}
        error={quoteState.error}
        reload={quoteState.reload}
        refreshing={isSilentRefresh}
      />
    </div>
  );
};
